import moment from "moment";
import { customerApi, isStrEmpty } from "@eforms/forms-common-ui";
import { ANALYTICS_SUMMARY, THANK_YOU_PAGE_TEXT } from "../../constants/Constants";
import { LOGIN_WITH_BANK, SESSION_STORAGE_KEY_CHANNEL } from "../authUtils";

const AUTOPOPULATE_FIELD_PREFIX = "customer_";
const STRING_FORMATS = {
  DATE: "date",
  SHOW_LAST_FOUR_CHARACTERS: "show_last_four_characters",
  UPPER_CASE: 'upperCase',
  LOWER_CASE: 'lowerCase',
  TITLE_CASE: 'titleCase'
};

export const getCustomerDetails = async (formUuid) => {
  const response = await customerApi.getLoggedInCustomerDetails({
    headers: {
      "x-form-uuid": formUuid,
    },
  });
  return response;
};

export const getAutofillValue = (value, type, format) => {
  if (type === "string" && !isStrEmpty(value)) {
    switch (format) {
      case STRING_FORMATS.DATE:
        return moment(value, "DD-MM-YYYY").format("YYYY-MM-DD");
      case STRING_FORMATS.SHOW_LAST_FOUR_CHARACTERS:
        return value.slice(-4);
      case STRING_FORMATS.UPPER_CASE:
        return value.toUpperCase();
      case STRING_FORMATS.LOWER_CASE:
        return value.toLowerCase();
      case STRING_FORMATS.TITLE_CASE:
        return value.toLowerCase().replace(/(?:^|\s)\w/g, (match) => match.toUpperCase());
      default:
        return value;
    }
  }
  return value;
};

export const autopopulateCustomerDetailsForGroupField=(definition,groupFieldPropertyName,propertyName,customerDetails,autopopulatedFields)=>{
  if (groupFieldPropertyName.startsWith(AUTOPOPULATE_FIELD_PREFIX)) {
    const fieldNameWithoutPrefix = groupFieldPropertyName.substring(
      AUTOPOPULATE_FIELD_PREFIX.length
    );
    if (Object.keys(customerDetails).includes(fieldNameWithoutPrefix)) {
       const dataSchemaProperties =
        definition.dataSchema.schema.properties?.[propertyName].properties?.[groupFieldPropertyName];
      if (customerDetails[fieldNameWithoutPrefix] !== "null") {
        const autofillValue = getAutofillValue(
          customerDetails[fieldNameWithoutPrefix],
           definition.dataSchema.schema.properties?.[propertyName].properties?.[groupFieldPropertyName].type,
           definition.dataSchema.schema.properties?.[propertyName].properties?.[groupFieldPropertyName].format
        );

       dataSchemaProperties.default = autofillValue;
       definition.dataSchema.schema.properties[propertyName].properties[groupFieldPropertyName]= dataSchemaProperties;
        autopopulatedFields.push(fieldNameWithoutPrefix);
      }
      const uiSchema = definition.uiSchema?.schema || {};
      const existingUISchemaProps = uiSchema[propertyName][groupFieldPropertyName] || {};
      uiSchema[propertyName][groupFieldPropertyName] = {
        ...existingUISchemaProps,
        "ui:disabled": true,
      };
      definition.uiSchema.schema = uiSchema;
    }
  }
};


export const autopopulateCustomerDetails = (
  formDefinition,
  customerDetails
) => {
  const autopopulatedFields = [];
  formDefinition.stepDefinitions.forEach((definition) => {
    // Check if dataSchema exists
    if (definition?.dataSchema?.schema?.properties) {
      // Iterate the fields
      Object.keys(definition.dataSchema.schema.properties).forEach(
        (propertyName) => {
          // Check if dataShema contains groupField
          if ((definition.dataSchema.schema.properties?.[propertyName]).type === "object" && (definition.dataSchema.schema.properties?.[propertyName]?.properties)  && ((definition.dataSchema.schema.properties?.[propertyName]).widget !== ANALYTICS_SUMMARY && definition.name !== THANK_YOU_PAGE_TEXT)){
            // Iterate group fields
            Object.keys(definition.dataSchema.schema.properties?.[propertyName].properties).forEach(
              (groupFieldPropertyName) => {
                autopopulateCustomerDetailsForGroupField(definition,groupFieldPropertyName,propertyName, customerDetails,autopopulatedFields);
              });
          }
          // check if field name from form definition starts with prefix
          if (propertyName.startsWith(AUTOPOPULATE_FIELD_PREFIX)) {
            const fieldNameWithoutPrefix = propertyName.substring(
              AUTOPOPULATE_FIELD_PREFIX.length
            );
            // Check if customerDetails keys has this field
            if (Object.keys(customerDetails).includes(fieldNameWithoutPrefix)) {
              // 1. Add default value to field's data schema
              const dataSchemaProperties =
                definition.dataSchema.schema.properties[propertyName];
              // Customer details API response may contain some values as 'null' (string) instead of null data type. For those cases, don't autofill. Just disable the field.
              if (customerDetails[fieldNameWithoutPrefix] !== "null") {
                const autofillValue = getAutofillValue(
                  customerDetails[fieldNameWithoutPrefix],
                  definition.dataSchema.schema.properties[propertyName].type,
                  definition.dataSchema.schema.properties[propertyName].format
                );

                dataSchemaProperties.default = autofillValue;
                definition.dataSchema.schema.properties[propertyName] =
                  dataSchemaProperties;
                autopopulatedFields.push(fieldNameWithoutPrefix);
              }
              // 2. Add disabled prop to ui:options
              const uiSchema = definition.uiSchema?.schema || {};
              const existingUISchemaProps = uiSchema[propertyName] || {};
              // 3. Disable only when the session is not from the LWB - Log in with bank
              const channel = sessionStorage.getItem(SESSION_STORAGE_KEY_CHANNEL);
              const disableField = !(channel === LOGIN_WITH_BANK && isStrEmpty(customerDetails[fieldNameWithoutPrefix]));
              uiSchema[propertyName] = {
                ...existingUISchemaProps,
                "ui:disabled": disableField,
              };

              definition.uiSchema.schema = uiSchema;
            }
          }
        }
      );
    }
  });
  // we are removing the autopopulated fields from customer details object so that we avoid sending duplicate values with different names (one with prefix and one without prefix) during form submission
  autopopulatedFields.forEach((fieldName) => {
    delete customerDetails[fieldName];
  });
};
